import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AidasUserAidasObjectMapping from './aidas-user-aidas-object-mapping';
import AidasUserAidasObjectMappingDetail from './aidas-user-aidas-object-mapping-detail';
import AidasUserAidasObjectMappingUpdate from './aidas-user-aidas-object-mapping-update';
import AidasUserAidasObjectMappingDeleteDialog from './aidas-user-aidas-object-mapping-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AidasUserAidasObjectMappingUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AidasUserAidasObjectMappingUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AidasUserAidasObjectMappingDetail} />
      <ErrorBoundaryRoute path={match.url} component={AidasUserAidasObjectMapping} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AidasUserAidasObjectMappingDeleteDialog} />
  </>
);

export default Routes;
